import moment from 'moment';

import {
  createSelector
} from 'reselect'

export const getMe = state => state.user.me;

export const getLoginState = state => state.user.isLogined;

export const getShirtProfiles = state => state.user.shirtProfiles;

export const isAddedToCart = state => state.user.isAddedToCart;

export const getCartData = state => state.user.productCart;



export const getSortedShirtProfiles = createSelector(
  getShirtProfiles,
  (profiles) => {
    profiles.sort((a, b) => {
      const aDate = moment(a.modifyDate);
      const bDate = moment(b.modifyDate);

      return bDate - aDate
    })

    return profiles;
  }
)

export const getPartnerState = createSelector(
  getLoginState,
  getMe,
  (logined, me) => {
    return (
      !logined ?
        false : me.partnerStatus === 'approved'
    )
  }
)
